define('SageDotCom/DataLayer/Events/fileDownload',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function FileDownloadEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "download"; // overwrite name
    }

    FileDownloadEvent.prototype = Object.create(EventBase.prototype);

    FileDownloadEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, fileName, label) {
        var eventData = {
            "event_name": this.getName(), //event name
            "event_non-int": "0", //non interaction point
            "event_category": "engagement", //top line category
            "event_action": this.getName() //specific action
        }

        if (scope) {
            var lbl = label || $(scope).attr("data-title") || $(scope).text() || $("a:first", scope).text() || "";
            var location = this.getLocation(scope);

            eventData = $.extend(eventData, {
                'event_label': this.stripHtml(lbl.trim()), // strip any html
                'event_name_level_1': this.getId(scope),
                'event_name_level_2': $(scope).attr("href") || $("a:first", scope).attr("href") || "",
                'event_name_level_3': fileName,
                'event_name_level_4': location
            });
        }

        return eventData;
    }

    return new FileDownloadEvent();
});
